import { Form } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";

const dryRefractionTb1: ColumnsType = [
  {
    title: "-",
    dataIndex: "none",
    align: "center",
  },
  {
    title: "Thị lực không kính",
    dataIndex: "ucva",
    align: "center",
  },
  {
    title: "Cầu",
    dataIndex: "sph",
    align: "center",
    className: "remain",
  },
  {
    title: "Trụ",
    align: "center",
    className: "remain",
    dataIndex: "cyl",
  },
  {
    title: "Trục",
    dataIndex: "axis",
    className: "remain",
    align: "center",
  },
  {
    title: "Thị lực với kính",
    dataIndex: "vision",
    align: "center",
  },
  {
    title: "Thị lực (kính lỗ)",
    dataIndex: "va",
    align: "center",
  },
];

export { dryRefractionTb1 };
